import { render, staticRenderFns } from "./GlobalWidgets.vue?vue&type=template&id=c1ae6848"
import script from "./GlobalWidgets.vue?vue&type=script&lang=js"
export * from "./GlobalWidgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports